import { createContext } from "react";
export const MenuListContext = createContext({
    listId: "",
    mode: "interactive",
    density: "comfortable"
});
